// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"102":"657aebff","107":"3921dd1c","111":"955b9252","167":"0b6cb9c3","177":"7ea9ef70","267":"b9afd4c6","372":"79bad5a9","567":"d0103b25","734":"770901fa","814":"cf54e83f"}[chunkId] + ".css";
};